import { useSearchParams } from "react-router-dom";

import { LearningMaterial } from "./LearningMaterial";
import { Message } from "./Message";
import { ServiceInformation } from "./ServiceInformation";
import { Summary } from "./Summary";
import { Syllabus } from "./Syllabus";

export function TabContent() {
	const [searchParams] = useSearchParams();
	const tab = searchParams.get("tab") ?? "";

	return (
		<div className="lesson-tab-content-container">
			<div style={{ display: tab === "learning-material" ? "block" : "none" }}>
				<LearningMaterial />
			</div>
			<div
				style={{ display: tab === "service-information" ? "block" : "none" }}>
				<ServiceInformation />
			</div>
			<div style={{ display: tab === "summary" ? "block" : "none" }}>
				<Summary />
			</div>
			<div style={{ display: tab === "syllabus" ? "block" : "none" }}>
				<Syllabus />
			</div>
			<div style={{ display: tab === "message" ? "block" : "none" }}>
				<Message />
			</div>
		</div>
	);
}
